// Utils
import { sendAmplitudeEvent } from '../../../../analytics/amplitudeService';

// Constants
import { HANDLER_RETURN_VALUES } from '../../draftjsConstants';
import { AMPLITUDE_USER_PROPS, TRACKED_FEATURES } from '../../../../../common/analytics/statsConstants';
import { EVENT_TYPE_NAMES } from '../../../../../common/analytics/amplitudeEventTypesUtil';

export default (editorState, newEditorState, { setEditorState }) => {
    if (editorState !== newEditorState) {
        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.MARKDOWN,
            userProperties: {
                [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.MARKDOWN]: true },
            },
        });

        setEditorState(newEditorState);
        return HANDLER_RETURN_VALUES.handled;
    }

    return HANDLER_RETURN_VALUES.notHandled;
};
